<template>
  <b-carousel
    id="slider-main"
    style="text-shadow: 1px 1px 2px #333;"
    controls
    indicators
    background="#ababab"
    :interval="4000"
    img-width="1024"
    img-height="480"
  >
    <b-carousel-slide
      :img-src="
        require('../assets/images/slider/slide-1.' + this.locale + '.png')
      "
    ></b-carousel-slide>
    <b-carousel-slide
      :img-src="
        require('../assets/images/slider/slide-2.' + this.locale + '.png')
      "
    ></b-carousel-slide>
  </b-carousel>
</template>

<script>
export default {
  data() {
    return {
      locale: this.$route.params.locale
    };
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  }
};
</script>
